import React, { Component } from "react";
import Modal from "../../../UIComponents/Modal";
import "./VideoModal.css";

class InfoModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let platform = "PLAYER";
        if (this.props.videoData) {
            if (this.props.videoData.platformName === "YouTube") platform = "Youtube Player";
            else if (this.props.videoData.platformName === "Instagram") platform = "Instagram Player";
            else if (this.props.videoData.platformName === "Twitter") platform = "Twitter Player";
            else platform = this.props.videoData.platformName;
        }

        return (
            <Modal className={this.props.className + " videoPlayer-modal"} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>{platform}</Modal.Header>
                <Modal.Content noSkipGTranslate={true}>
                    {this.props.videoData && (
                        <div className="videoPlayer">
                            <iframe width="100%" height="100%" src={this.props.videoData.url} frameBorder="0" allowFullScreen></iframe>
                        </div>
                    )}
                    {this.props.videoData && (
                        <div className="videoTitle">
                            <p>{this.props.videoData.title}</p>
                        </div>
                    )}
                </Modal.Content>
            </Modal>
        );
    }
}

export default InfoModal;
